import replace from "lodash-es/replace";

export const computeSubtotal = (price: number, quantity: number): number => {
  return price * quantity;
};

export const formatNumber = (nb: number, precision: number = 2): string => {
  return nb.toFixed(precision).replace(/\d(?=(\d{3})+\.)/g, "$& ");
};

export const formatNumberWithSpaces = (x: string): string => {
  return replace(x, /\B(?=(\d{3})+(?!\d))/g, " ");
};

export const formatPhoneNumber = (x: string): string => {
  return replace(x, /(.{2})/g, (match: string): string => " " + match);
};

export const formatVolume = (
  volume: string | number | null | undefined
): string | undefined => {
  let match;
  if (typeof volume === "string") {
    // try to extract unit from string
    match = volume.match(/^(\d+(?:\.\d+)?)([mcd]?l)$/i);
    if (match !== null) {
      volume = parseFloat(match[1]);
      switch (match[2].toLowerCase()) {
        case "l":
          volume *= 100;
          break;
        case "dl":
          volume *= 10;
          break;
        case "ml":
          volume /= 10;
          break;
      }
    } else {
      volume = parseFloat(volume);
    }
  }

  // not positive number ?
  if (!(typeof volume === "number" && volume > 0)) {
    return "";
  }

  // guess unit based on value if not provided
  if (!match && volume < 2) {
    volume *= 100;
  }

  if (volume >= 100) {
    return `${volume / 100}L`;
  } else {
    return `${volume}cl`;
  }
};

export const formatPrice = (
  nb: string | number,
  precision: number = 2
): string => {
  if (typeof nb === "string") {
    nb = parseFloat(nb);
  }

  return formatNumber(nb, precision);
};

export const convertNumberToString = (
  numberToStringify?: number | null
): string | undefined | null => {
  if (numberToStringify == null) {
    return numberToStringify;
  }

  return numberToStringify.toString();
};
